export default __webpack_public_path__ + "static/media/empty_apps.92d8de96.png";